var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barra-de-percentual",class:{ 'barra-de-percentual--escura': _vm.$vuetify.theme.dark }},[_c('div',{staticClass:"barra-de-percentual__preenchimento",style:({ width: (_vm.largura + "%"), backgroundColor: _vm.cor })})])}
var staticRenderFns = []

export { render, staticRenderFns }